import {GameStateEnums} from '../../../../shared/GameEnums.ts'
import {ArrayUtils} from '@colonist/utils'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums

export interface UIGameMechanic {
    onEvent(data: any, eventType: UIGameEventEnums)
}

export interface UIGameAnimation {
    onGameTick(deltaTime: number, elapsedMS: number)
}

export class UIGameEventController {
    private readonly uiGameMechanics: UIGameMechanic[]
    private readonly uiGameAnimations: UIGameAnimation[]

    constructor() {
        this.uiGameMechanics = []
        this.uiGameAnimations = []
    }

    registerUIGameMechanic(uiGameMechanic: UIGameMechanic) {
        if(ArrayUtils.elementInArray(this.uiGameMechanics, uiGameMechanic)) return
        this.uiGameMechanics.push(uiGameMechanic)
    }

    isAlreadyRegistered(uiGameMechanic: UIGameMechanic) {
        return ArrayUtils.elementInArray(this.uiGameMechanics, uiGameMechanic)
    }

    unregisterUIGameMechanic(uiGameMechanic: UIGameMechanic) {
        ArrayUtils.removeElementFromArray(this.uiGameMechanics, uiGameMechanic)
    }

    sendEvent(data: any, notificationType: UIGameEventEnums) {
        for(const uiGameMechanic of this.uiGameMechanics) {
            uiGameMechanic.onEvent(data, notificationType)
        }
    }

    registerUIGameAnimation(uiGameAnimation: UIGameAnimation) {
        if(ArrayUtils.elementInArray(this.uiGameAnimations, uiGameAnimation)) return
        this.uiGameAnimations.push(uiGameAnimation)
    }

    unregisterUIGameAnimation(uiGameAnimation: UIGameAnimation) {
        ArrayUtils.removeElementFromArray(this.uiGameAnimations, uiGameAnimation)
    }

    gameTick(deltaTime: number, elapsedMS: number) {
        for(const uiGameAnimation of this.uiGameAnimations) {
            uiGameAnimation.onGameTick(deltaTime, elapsedMS)
        }
    }
}
